// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_l3-5";
export var filledCircle = "_l3-4";
export var historyEntry = "_l3-3";
export var messageSideLeft = "_l3-1";
export var messageSideRight = "_l3-2";
export var orderTrackingCarouselWrapper = "_l3-6";
export var orderTrackingInfoContainer = "_l3-0";